export const extensionByName = name => {
    const ext = name.split('.').pop();
    if (name.includes('.')) {
        return ext.toLowerCase();
    }
    return '';
};
